import { Typography } from 'antd'
import styled from 'styled-components'

const StyledSearchHighlightedSpan = styled(Typography.Text)`
  background-color: ${({ theme }) => theme.colors.purple};
`

export default StyledSearchHighlightedSpan
